/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/src/components/shad/carousel";
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import Autoplay from "embla-carousel-autoplay";

interface Props {
  data: string[] | undefined;
}

const Banner = ({ data }: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [banners, setBanners] = useState("");
  useEffect(() => {
    const intervalId = setInterval(() => {
      // Display the current item
      setBanners(data![currentIndex]);

      // Move to the next item
      setCurrentIndex((prevIndex) => (prevIndex + 1) % data!.length);
    }, 10000); // 10 seconds

    // Cleanup the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [currentIndex, data]);

  useEffect(() => {
    setBanners(data![0]);
  }, [data]);

  if (isEmpty(banners)) return null;

  return (
    <>
      {/* <img
        className="h-[20vh] w-full md:hidden rounded-lg"
        src={banners}
        alt="banner"
      /> */}
      <div className="flex justify-between overflow-x-hidden gap-6 ">
        <Carousel
          plugins={[
            Autoplay({
              delay: 5000,
            }),
          ]}
        >
          <CarouselContent>
            {data?.map((item, index) => (
              <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                <img
                  key={index}
                  className="md:h-[15vh] h-[20vh] w-full rounded-lg"
                  src={item}
                  alt="banner"
                />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </div>
    </>
  );
};

export default Banner;
